module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-logo-backcounty.3b4b4ff.jpg";